import React from "react";
import { Box } from "@mui/material";
import Accessibility from "../Asset/Images/Dimensions/Accessibility.jpg";
import Achievement from "../Asset/Images/Dimensions/Achievement.jpg";
import Community from "../Asset/Images/Dimensions/Community.jpg";
import Education from "../Asset/Images/Dimensions/Education.jpg";
import Growth from "../Asset/Images/Dimensions/Growth.jpg";
import Health from "../Asset/Images/Dimensions/Health.jpg";
import Knowledge from "../Asset/Images/Dimensions/Knowledge.jpg";
import Environment from "../Asset/Images/Dimensions/Environment.jpg";
import theme from "../theme";

const images = [
  { name: "Icon Image", src: Health },
  { name: "Icon Image", src: Achievement },
  { name: "Icon Image", src: Community },
  { name: "Icon Image", src: Knowledge },
  { name: "Icon Image", src: Accessibility },
  { name: "Icon Image", src: Education },
  { name: "Icon Image", src: Growth },
  { name: "Icon Image", src: Environment },
];

const EightDimensions = () => {
  return (
    <Box
      id="AboutUs"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: { xs: 4, sm: 4, md: 3 },
        justifyContent: "center",
        alignItems: "center",
        verticalAlign: "middle",
        py: 10,
      }}
    >
      <Box
        sx={{
          border: `2px solid ${theme.palette.primary.main}`,
          borderRadius: "14px",
          display: "flex",
          px: 1,
          pt: 1,
        }}
      >
        {images.map((item, index) => (
          <Box key={index}>
            <Box
              component="img"
              src={item.src}
              alt={item.name}
              sx={{
                height: { xs: 30, sm: 50, md: 60 },
                width: { xs: 30, sm: 50, md: 60 },
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default EightDimensions;
